/**
 * Cart upsell "Potrebbe interessarti anche" (BAU-34).
 *
 * Aggiunta al carrello con un solo clic per singola card: si legge la variante
 * scelta nel selettore (o l'unica disponibile) e si aggiunge direttamente, senza
 * checkbox ne' bottone batch. Dopo l'aggiunta emette `cart:refresh`, che il tema
 * usa gia' per rigenerare body e footer del drawer via Section Rendering API.
 *
 * Delega gli eventi al documento perche' il drawer viene rigenerato via innerHTML
 * a ogni aggiornamento: listener diretti sui nodi si perderebbero.
 */
(function () {
  'use strict';

  function addFromCard(button) {
    var item = button.closest('[data-upsell-item]');
    if (!item) return;

    var input = item.querySelector('[data-upsell-variant]');
    var variantId = input && input.value;
    if (!variantId) return;

    button.setAttribute('disabled', '');
    button.classList.add('is-loading');

    var addUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Errore');
        return res.json();
      })
      .then(function () {
        // Il tema ricostruisce body e footer del drawer da qui; nessun reload.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (error) {
        console.error('Cart upsell: aggiunta al carrello fallita', error);
        button.removeAttribute('disabled');
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-upsell-add]');
    if (button) addFromCard(button);
  });
})();
